import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app/app.service';
import { CategoryService } from 'src/app/services/category/category.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from 'src/app/components/layout/error/error.component';
import { AppCategoryComponent } from '../app-category/app-category.component';
import { LanguageSelectorComponent } from 'src/app/components/layout/language-selector/language-selector.component';
import { LoadingSkeletonComponent } from 'src/app//components/layout/loading-skeleton/loading-skeleton.component';
import { AppUploadImgComponent } from './app-upload-img/app-upload-img.component';


@Component({
  selector: 'app-app-products',
  standalone: true,
  imports: [
    CommonModule,
    ErrorComponent,
    AppCategoryComponent,
    FormsModule,
    LanguageSelectorComponent,
    ReactiveFormsModule,
    TranslateModule,
    LoadingSkeletonComponent,
    AppUploadImgComponent,
],
  templateUrl: './app-products.component.html',
  styleUrls: ['./app-products.component.css']
})
export class AppProductsComponent {

  @ViewChild('addProductModal') addProductModal: any;

  id = 0;
  data: any;
  load = false;
  error = false;

  addProduct = false;
  isProductLoad = false;
  isEdit = false;
  form!: FormGroup;

  selectedLanguage = '';
  systemLang = '';
  selectedFile = '';

  categories: any
  catLoad = false
  userId = 0

  showLoad = false
  showLoadid = ''
  deleteLoad = false
  deleteLoadid = ''
  loadCheck = false
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private ToastrService: ToastrService,
    private ProductsService: ProductsService,
    private fb: FormBuilder,
    private LanguagesService: LanguagesService,
    private Router: Router,
    private CategoryService: CategoryService,
    private translate: TranslateService,
    private adminService: AdminService,
    private modalService: NgbModal,
    private AppService: AppService

  ) {
    
    this.activatedRoute.params.subscribe(
      params => {
        if (params['id']) {
          this.id = params['id'];
        }
      }
    );
    this.loadCheck = true   
    this.AppService.checkAppOneAuth(this.id).subscribe(
      (res: any) => {
        this.loadCheck = false   
        
        console.log('app: ', res.data)
        
      },
      (error: any) => {
        this.loadCheck = false  
          Router.navigate(['/'])
      }
    )



    this.LanguagesService.productCategoryLanguage$.subscribe(lang => {
      this.selectedLanguage = lang
    });
    this.LanguagesService.selectedLanguage$.subscribe(lang => {
      this.systemLang = lang.code
    })

    this.get();
    this.initializeForm();
    this.getCategories()
  }




  initializeForm() {
    this.form = this.fb.group({
      id: [null],
      titles: this.fb.array([]), // ცარიელი ფორმარაი
      image: ['', Validators.required],
      price: ['0.00', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      cat_id: ['0', Validators.required],
      app_id: [this.id],
      show: [1],
      sale: [0.00, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    });
    this.addLanguageField();
  }

  get titles(): FormArray {
    return this.form.get('titles') as FormArray;
  }

  getIngredients(formGroup: AbstractControl): FormArray {
    return formGroup.get('ingredients') as FormArray;
  }

  addLanguageField(): void {

    // მხოლოდ მაშინ უნდა დავამატოთ ველი, თუ ის ჯერ არ არსებობს
    const existingFieldIndex = this.titles.controls.findIndex(control => control.get('language')?.value === this.selectedLanguage);
  
    if (existingFieldIndex === -1) {
      this.titles.push(this.fb.group({
        language: [this.selectedLanguage, Validators.required],
        value: ['', Validators.required],
        description: ['', Validators.required],
        ingredients: this.fb.array([]) // ინგრედიენტები ველის მასივი
      }));
    }
  }

  addIngredient(index: number): void {
    const ingredients = this.getIngredients(this.titles.at(index));
    ingredients.push(this.fb.group({
      check: [true, Validators.required],
      type: [false, Validators.required],
      name: ['', Validators.required],
      ig_price: ['', Validators.required]
    }));
  }

  removeIngredient(index: number, ingredientIndex: number): void {
    const ingredients = this.getIngredients(this.titles.at(index));
    ingredients.removeAt(ingredientIndex);
  }

  get() {
    this.load = true;
    this.ProductsService.getProducts(this.adminService.user.id.toString(), this.id.toString()).subscribe(
      (res: any) => {
        this.load = false;
        console.log('products: ', res)
        this.data = res
        this.error = false;
      },
      (error: any) => {
        console.log(error)
        this.load = false;
        this.error = true;
        if(error?.error?.not_my_app){
          this.Router.navigate(['/not-found'])
        }
      }
    );
  }



openAddProduct() {
    console.log(1, this.form.get('show').value)

    this.addProduct = true;
    this.isEdit = false;
    this.form.reset();
    this.form.setControl('titles', this.fb.array([])); // ვასუფთავებთ titles array-ს
    this.addLanguageField(); // ენას ვამატებთ მხოლოდ ახალ პროდუქტზე
    this.form.get('show').setValue(1)

}

  closeAddProduct() {
    this.addProduct = false;
  }

  addNewProduct() {
    this.isEdit = false;
  
    this.form.reset(); // ფორმის გასუფთავება
    this.selectedFile = null;
  
    const titlesArray = this.form.get('titles') as FormArray;
    titlesArray.clear();
  
  
    this.selectedLanguage = this.systemLang;
  
    this.openAddProductModal();
  }


  openAddProductModal() {
    this.modalService.open(this.addProductModal, { size: 'lg', backdrop: 'static' });
  }

editProduct(product: any) {
  // console.log('edit: ', product);

  // this.openAddProduct();

  this.isEdit = true;
  this.openAddProductModal(); // ✅ მოდალის გახსნა უკვე ახალ სტილში


  // ვამოწმებთ ველებს, რომ საჭირო მონაცემები არ დაიკარგოს
  this.form.patchValue({
      id: product.id,
      image: product.image,
      price: product.price || '0.00',
      app_id: this.id,
      cat_id: product.category_id || this.form.get('cat_id')?.value, // კატეგორიის ID
      show: product.show  // შოუს ველი
  });
  console.log('forms:', this.form.get('show')?.value)

  // განახლებული სურათის დამატება
  this.selectedFile = product.image;

  // ვამატებთ მონაცემებს titles-ისთვის
  const titlesArray = this.form.get('titles') as FormArray;
  titlesArray.clear(); // ვასუფთავებთ დასაწყისში

  // JSON მონაცემების გაშიფვრა
  const titlesObj = product.product_name || {};
  const descriptionsObj = product.descriptions || {};
  const ingredientsObj = product.ingredients || {};

  Object.keys(titlesObj).forEach((lang) => {
    if (!titlesObj[lang]) titlesObj[lang] = ''; // ცარიელი მნიშვნელობის შეცვლა
  });

  Object.keys(descriptionsObj).forEach((lang) => {
      if (!descriptionsObj[lang]) descriptionsObj[lang] = ''; // ცარიელი მნიშვნელობის შეცვლა
  });

  const titles = Object.keys(titlesObj).map(key => ({
      language: key, // ვამატებთ ენის კოდს
      value: titlesObj[key],
      description: descriptionsObj[key] || '',
      ingredients: ingredientsObj[key] || [] // ინგრედიენტები ენაზე
  }));

  titles.forEach((title: any) => {
      const ingredientsArray = this.fb.array([]) as FormArray;

      if (Array.isArray(title.ingredients)) {
          title.ingredients.forEach((ingredient: any) => {
              ingredientsArray.push(this.fb.group({
                  check: [ingredient.check, Validators.required],
                  type: [ingredient.type, Validators.required],
                  name: [ingredient.name, Validators.required],
                  ig_price: [ingredient.ig_price, Validators.required]
              }));
          });
      }
      console.log('lang: ', title.language)
      titlesArray.push(this.fb.group({
          language: [title.language, Validators.required],
          value: [title.value, Validators.required],
          description: [title.description, Validators.required],
          ingredients: ingredientsArray
      }));
  });
  if (!titles.find((t) => t.language === this.selectedLanguage)) {
    this.selectedLanguage = titles[0]?.language || ''; // პირველი ენა ან ცარიელი
}

  if (titles.length > 0) {
      this.selectedLanguage = titles[0].language; // ენის პირველ მნიშვნელობაზე დაყენება
  }
  // console.log('Titles Object:', titlesObj);
  // console.log('Descriptions Object:', descriptionsObj);
  // console.log('Ingredients Object:', ingredientsObj);
  // console.log('Form after editing:', this.form.value);
}


onProductIdGenerated(data: any) {
  // ვამოწმებთ რომ ID სწორად ჩაიწეროს
  console.log('data: ',  data)
  this.form.get('id')?.setValue(data.productId);
  console.log('ახალი სურათი: ',    )
  
  this.form.get('image')?.setValue(data.file_url);
  // // პროდუქტების სერვისის გამოძახება ახალი პროდუქტის მონაცემების ასაღებად
  // this.ProductsService.getProductById(this.adminService.user.id.toString(), this.id.toString(), newProductId).subscribe(
  //   (product: any) => {
  //     console.log('ბაზიდან წამოსული პროდუცია: ', product)
  //     this.form.get('image')?.setValue(product.image);
  //   },
  //   (error: any) => {
  //     console.error('Error loading product data:', error);
  //   }
  // );
  // console.log('ატვირთვის შემდეგ ფორმა: ', this.form.value);
}

createOrUpdate() {

  this.form.get('app_id')?.setValue(this.id); // app_id ივსება
  const user_id = this.adminService.user.id;

  const titles: { [key: string]: string } = {};
  const descriptions: { [key: string]: string } = {};
  const ingredients: { [key: string]: any[] } = {}; // Ingredients should be an array of objects

  this.form.value.titles.forEach((title: any) => {
      titles[title.language] = title.value;
      descriptions[title.language] = title.description;
      ingredients[title.language] = title.ingredients.map((ingredient: any) => ({
          check: ingredient.check,
          type: ingredient.type,
          name: ingredient.name,
          ig_price: ingredient.ig_price
      }));
  });

  const show = this.form.get('show').value ? 1 : 0;

  const productData = {
      ...this.form.value,
      titles,
      descriptions,
      ingredients,
      show,
      user_id // დაამატეთ user_id
  };

  this.isProductLoad = true;
  this.ProductsService.createOrUpdate(productData).subscribe(
      (res: any) => {
        console.log(res)
          this.isProductLoad = false;
          // this.addProduct = false;
          this.get(); // Refresh the product list
          this.ToastrService.success('success delete')
      },
      (error: any) => {
        console.log(error)
          this.isProductLoad = false;
          this.error = true;
          if (error.error && error.error.error) {
              this.translate.get(error.error.error).subscribe((translatedMessage: string) => {
                  this.ToastrService.error(translatedMessage);
              });
          }
          this.ToastrService.error('error')
      }
  );
}


deleteProduct(id: string) {

  if(confirm('Are you sure you want to delete?')){

    const data = {
      userId: this.adminService.user.id,
      appId: this.id.toString(),
      productId: id
    };
    this.deleteLoad = true
    this.deleteLoadid = id
 

    this.ProductsService.delete(data).subscribe(
      (res: any) => {
        // console.log(res)
        this.ToastrService.success('success delete')
        this.get()
        this.deleteLoad = false
        this.deleteLoadid = ''
      },
      (error: any) => {
        // console.log(error)
        this.ToastrService.error('error delete')
        this.deleteLoad = false
        this.deleteLoadid = ''

      }
    )
  }
}

  getCategories() {
    this.catLoad = true;
    this.CategoryService.getCategories(this.adminService.user.id.toString(), this.id.toString()).subscribe(
      (res: any) => {
        console.log('category: ',res)
        this.catLoad = false;
        this.categories = res
        this.error = false;
      },
      (error: any) => {
        this.catLoad = false;
        this.error = true;
      }
    );
  }

  setShow(item: any){
    // console.log(item)
    item.show = !item.show
    this.form.get('show').setValue(item.show)
    // console.log(this.form.get('show').value)
    this.showLoadid = item.id

    const data = {
      userId: this.adminService.user.id,
      appId: this.id.toString(),
      productId: item.id,
      show: item.show ? 1 :0
      
    }
    this.showLoad = true
    this.ProductsService.setShow(data).subscribe(
      (res: any) => {
        // console.log(res)
        this.showLoad = false
        this.showLoadid = ''
      },
      (error: any) => {
        this.showLoad = false
        this.showLoadid = ''

      }
    )
  }




}